var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"row form-row"},[_c('div',{staticClass:"col-md-2 form-row-label"},[_c('span',[_vm._v(" "+_vm._s(_vm.label)+" ")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10 form-row-input",staticStyle:{"background-color":"white"}},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }